import React, { useRef } from 'react';

interface DataManagementToolsProps {
  isAdmin: boolean;
  currentData?: any;
  onImport?: (data: any) => void;
  onAdminExportClick?: () => void; // ฟังก์ชันสำหรับส่งข้อมูลขึ้น Server (API)
}

const DataManagementTools: React.FC<DataManagementToolsProps> = ({
  isAdmin,
  currentData,
  onImport,
  onAdminExportClick
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  // --- สำหรับ Admin: Export ลงเครื่องเป็นไฟล์ JSON ---
  const handleLocalExport = () => {
    if (!currentData) return alert("ไม่มีข้อมูลสำหรับการ Export");
    const dataStr = JSON.stringify(currentData, null, 2);
    const dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
    const exportFileDefaultName = `trading-data-${new Date().toISOString().slice(0, 10)}.json`;
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
  };

  // --- สำหรับ User: Import ข้อมูลจากไฟล์ JSON ---
  const handleImport = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const json = JSON.parse(e.target?.result as string);
        if (onImport) onImport(json);
        alert("Import ข้อมูลสำเร็จ!");
      } catch (err) {
        alert("ไฟล์ JSON ไม่ถูกต้อง");
      }
    };
    reader.readAsText(file);
    event.target.value = ""; // Reset input เพื่อให้เลือกไฟล์เดิมซ้ำได้
  };

  return (
    <div className="flex gap-2">
      {isAdmin ? (
        /* --- ฝั่ง Admin: แสดงปุ่มจัดการข้อมูล --- */
        <div className="flex gap-2">

          {/* 2. ปุ่มส่งข้อมูลขึ้น Server (API) ที่เราสร้างไว้ก่อนหน้า */}
          {onAdminExportClick && (
            <button
              onClick={onAdminExportClick}
                  className="flex items-center gap-2 px-3 py-1.5 bg-blue-600 hover:bg-blue-500 text-white rounded-lg text-xs font-bold transition-all shadow-lg active:scale-95 group relative overflow-hidden"
            >
              🚀 Export
            </button>
          )}
        </div>
      ) : (
        /* --- ฝั่ง User: แสดงปุ่ม Import --- */
        <div>
          <button
            onClick={() => fileInputRef.current?.click()}
            className="flex items-center gap-2 px-3 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-xs font-bold transition-all shadow-lg active:scale-95 group relative overflow-hidden"
          >
            📥 Import JSON
          </button>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleImport}
            className="hidden"
            accept=".json"
          />
        </div>
      )}
    </div>
  );
};

export default DataManagementTools;